module.exports = __webpack_public_path__ + "img/the-last-tudor.a29936a9.png";